import { render, staticRenderFns } from "./display.vue?vue&type=template&id=7f142b85&scoped=true"
import script from "./display.vue?vue&type=script&lang=js"
export * from "./display.vue?vue&type=script&lang=js"
import style0 from "./display.vue?vue&type=style&index=0&id=7f142b85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f142b85",
  null
  
)

export default component.exports